import type { ReactElement } from "react";

/**
 * `P1-DLW-051` follow-up (Designer R's remark on #909, the architect: cheap, booked): **a hyphenated compound in a served sentence (« fixez-le », « peut-être ») is never broken across two lines.**
 *
 * The sentence is the door's and is drawn VERBATIM: nothing is replaced (no non-breaking hyphen, which would change the text a person copies); each compound is wrapped in a no-wrap span, so `textContent` is exactly what the door sent. A sentence with no compound is drawn as it came.
 */
const COMPOUND = /(\p{L}+(?:-\p{L}+)+)/u;

export function HeldCompounds(props: { readonly text: string }): ReactElement {
  return (
    <>
      {props.text.split(COMPOUND).map((part, index) =>
        index % 2 === 1 ? (
          <span key={`${String(index)}-${part}`} className="whitespace-nowrap">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
}
